import { type QueryClient } from "@tanstack/react-query"
import { TOKEN_KEY } from "lib/axios"
import { resetDeveloperMode } from "modules/shared/lib/developerMode"

type Props = {
  queryClient: QueryClient
  token: string
}

export function setAuthToken({ queryClient, token }: Props) {
  resetDeveloperMode()
  localStorage.setItem(TOKEN_KEY, token)
  queryClient.clear()
}
